import { CheckboxColor } from "@/common/enum/checkbox-color";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { TableHeader } from "@/types/table-header";
import { Checkbox, Table } from "flowbite-react";
import { useState } from "react";
import { CustomCell } from "../CustomCell";
import { ItemAllDiscountsTableFooter } from "./ItemAllDiscountsTableFooter";
import { ItemAllDiscountsTableRow } from "./ItemAllDiscountsTableRow";

interface Props {
  itemPage: BasePageDto<ItemDetailDto>;
  handlePageChange: (currentPage: number) => void;
  handleAddToSelectedItems: (selectedItemIds: number[]) => void;
}

const headers: TableHeader[] = [
  { title: "상품명", width: "w-[972px]" },
  { title: "모델명", width: "w-[160px]" },
  { title: "코드명", width: "w-[160px]" },
  { title: "카테고리", width: "w-[100px]" },
  { title: "할인율", width: "w-[100px]" },
  { title: "할인된 판매가", width: "w-[100px]" },
];

export const ItemAllDiscountsTable: React.FC<Props> = ({
  itemPage,
  handlePageChange,
  handleAddToSelectedItems,
}) => {
  const [checkedItemIds, setCheckedItemIds] = useState<number[]>([]);

  const items = itemPage.contents;

  const handleAddDiscountsButtonClick = () => {
    handleAddToSelectedItems(checkedItemIds);
    setCheckedItemIds([]);
  };

  const handleCheckAll = () => {
    const isChecked = checkedItemIds.length === items.length;
    if (isChecked) {
      setCheckedItemIds([]);
    } else {
      const allItemIds = items.map((item) => item.id);
      setCheckedItemIds(allItemIds);
    }
  };

  const handleCheckItem = (itemId: number) => {
    const isChecked = checkedItemIds.includes(itemId);
    if (isChecked) {
      setCheckedItemIds((prev) => prev.filter((id) => id !== itemId));
    } else {
      setCheckedItemIds((prev) => [...prev, itemId]);
    }
  };

  return (
    <div className="h-[420px] w-[1648px] overflow-x-auto rounded-lg border bg-white">
      <Table>
        <Table.Head>
          <Table.HeadCell className="w-[52px] flex items-center justify-center">
            <Checkbox
              color={
                checkedItemIds.length === items.length ? CheckboxColor.DARK : ""
              }
              checked={checkedItemIds.length === items.length}
              onChange={handleCheckAll}
            />
          </Table.HeadCell>
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px] p-0 border-b"}
            >
              <CustomCell>
                <Footnote12Description
                  className={"text-semantic-text-secondary"}
                >
                  {header.title}
                </Footnote12Description>
              </CustomCell>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {items.map((item) => (
            <ItemAllDiscountsTableRow
              key={item.id}
              item={item}
              checkedItemIds={checkedItemIds}
              handleCheckItem={handleCheckItem}
            />
          ))}
          <ItemAllDiscountsTableFooter
            headersLength={Object.values(headers).length}
            handleAddDiscountsButtonClick={handleAddDiscountsButtonClick}
          />
        </Table.Body>
      </Table>
    </div>
  );
};
